import { create } from 'apisauce'
import { getBackendUrls } from '../../config/backendEnv'

const api = create({
  baseURL: getBackendUrls().powerapps,
})


api.addResponseTransform(response => {
  if (!response.ok) throw response
})

export default api
